import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import DeptLeft from '../People/Dept_Left'

const HD = [
    {
        "Name": "Dr. Rajib Biswas",
        "NameLink": "/dr-rajib-biswas",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Theoretical and Computational Chemistry",
        "Phone": "0877 250 3100 / 3107",
        "Email": "hod_cy@iittp.ac.in / rajib@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Rajib.jpg"
    }

]
const Faculty = [

     {
        "Name": "Prof. Gouriprasanna Roy",
        "NameLink": "/dr-gouriprasanna-roy",
        "Position": "Professor",
        "Degree": "Ph.D - Department of Inorganic and Physical Chemistry (IPC), Indian Institute of Science (IISc), Bangalore.",
        "AreasofInterest": "Chemical Biology, Bioinorganic Chemistry",
        "Phone": "+91-9871317927",
        "Email": " gproy@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Gouriprasanna%20Roy.jpg"
    },
    {
        "Name": "Dr. Arun K Manna",
        "NameLink": "/dr-arun-k-manna",
        "Position": "Associate Professor",
        "Degree": "Ph.D - JNCASR, Bangalore, India",
        "AreasofInterest": "Theoretical and Computational Chemistry",
        "Phone": "0877 250 3105",
        "Email": "arun@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/arun.jpg"
    },
    {
        "Name": "Dr. Debasish Mondal",
        "NameLink": "/dr-debasish-mondal",
        "Position": "Associate Professor",
        "Degree": "Ph.D - IACS, Kolkata, India",
        "AreasofInterest": "Theoretical and Computational Chemistry (Non-equilibrium Statistical Mechanics)",
        "Phone": "0877 250 3106",
        "Email": "debasish@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/dmondal.jpg"
    },
    {
        "Name": "Dr. P. Gandeepan",
        "NameLink": "/dr-p-gandeepan",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Department of Chemistry, National Tsing Hua University, Hsinchu, Taiwan",
        "AreasofInterest": "Transition Metal Catalysis, Sustainable Organic Synthesis",
        "Phone": "0877 250 3108",
        "Email": "pgandeepan@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/gandeepan.jpg"
    },
     {
        "Name": "Dr. Sourav Chakraborty",
        "NameLink": "/dr-sourav-chakraborty",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Department of Inorganic Chemistry, Indian Association for the Cultivation of Science, Kolkata (2016)",
        "AreasofInterest": "Supramolecular Chemistry, Material science",
        "Phone": "0877 250 3109",
        "Email": "sourav@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/sourav.png"
    },
    
    // {
    //     "Name": "Dr. Ashish Kulkarni",
    //     "NameLink": "/dr-ashish-kulkarni",
    //     "Position": "Assistant Professor",
    //     "Degree": "Ph.D - Toin University of Yokohama, Japan",
    //     "AreasofInterest": "Halide Perovskite Solar Cells, Silicon-Perovskite Tandem Solar Cells",
    //     "Phone": "+91 7416393779",
    //     "Email": "ashish.kulkarni@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Ashish_Kulkarni_AP.png"
    // },
    {
        "Name": "Dr. Kaushik Pal",
        "NameLink": "/dr-kaushik-pal",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - IISER Bhopal, India, 2018",
        "AreasofInterest": "Fluorescence Spectroscopy and Microscopy, Biophysical Chemistry",
        "Phone": "+91 9685223209",
        "Email": "reachkaushik@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Kaushik.jpg"
    },
    {
        "Name": "Dr. Mahendra K. Sharma",
        "NameLink": "/dr-mahendra-k-sharma",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Delhi",
        "AreasofInterest": "Main Group Chemistry, Inorganic and Organometallic Chemistry",
        "Phone": " ",
        "Email": "msharma@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Mahendra_K_Sharma_AP.png"
    },
    {
        "Name": "Dr. Prasenjit Mondal",
        "NameLink": "/dr-prasenjit-mondal",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Bombay, India (2016)",
        "AreasofInterest": "Coordination Chemistry and Bioinorganic Chemistry",
        "Phone": "+91-9163626604",
        "Email": "prasenjit@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/prasanjit.jpg"
    },
    {
        "Name": "Dr. Sattwick Haldar",
        "NameLink": "/dr-sattwick-haldar",
        "Position": "Assistant Professor",
        "Degree": "Ph.D -  Center for Energy Science and Chemistry Department, IISER Pune, India",
        "AreasofInterest": "Sustainable Battery and Electrochemistry, Functional Organo-Polymers and Frameworks",
        "Phone": "+91-7219064255",
        "Email": "sattwick07@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Sattwick_Haldar_AP.png"
    },
    {
        "Name": "Dr. Someswara Rao Sanapala",
        "NameLink": "/dr-someswara-rao-sanapala",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Organic Chemistry, IIT Bombay, India",
        "AreasofInterest": "Carbohydrate Chemistry & Oligosaccharide synthesis, Vaccine Adjuvants",
        "Phone": "+91-7702626088",
        "Email": "somesh@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Somesh.PNG"
    },
   
    {
        "Name": "Dr. Srikrishna Bera",
        "NameLink": "/dr-srikrishna-bera",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Institute of Organic Chemistry, Westfälische Wilhelms-Universität (WWU) Münster, Germany",
        "AreasofInterest": "Reaction Development, Asymmetric Synthesis",
        "Phone": "0877 250 3110",
        "Email": "sbera@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SB.jpg"
    },
    {
        "Name": "Dr. Sudhakar Pagidi",
        "NameLink": "/dr-sudhakar-pagidi",
        "Position": "Assistant Professor",
        "Degree": "Int.Ph.D - Indian Institute of Science",
        "AreasofInterest": "Conjugated Organic Functional Materials Featuring Main Group Elements",
        "Phone": "+91-8074036011",
        "Email": "psudhakar@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Sudhakar_AP.png"
    },
    {
        "Name": "Dr. Venkaiah Chintalapudi",
        "NameLink": "/dr-venkaiah-chintalapudi",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - School of Chemistry, University of Hyderabad, Hyderabad",
        "AreasofInterest": "Total synthesis of bioactive natural products, Asymmetric catalysis",
        "Phone": "+91-8008529348",
        "Email": "venky@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr. Venkaiah Chintalapudi.jpg"
    },
   /* {
        "Name": "Dr. Somrita Ray",
        "NameLink": "/dr-somrita-ray",
        "Position": "DST-INSPIRE Faculty",
        "Degree": "Ph.D - Visva-Bharati University, India",
        "AreasofInterest": "Theoretical Chemistry",
        "Phone": "0877 250 3507",
        "Email": "somrita@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SRay.jpg"
    }*/

]
const AdjunctFaculty = [
    {
        "Name": "Dr. Chebrolu Pulla Rao",
        "NameLink": "#",
        "Position": "Retd. Professor",
        "Category": "Adjunct Faculty",
        "Degree": "Ph.D., Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Bioinorganic chemistry including chemosensors Materials for water purification and in drug delivery including anticancer agents ",
        "Email": "cprao@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/CPRao.png"
    }
]
const GuestFaculty = [

    {
        "Name": "Prof. Vijayamohanan K Pillai",
        "NameLink": "#",
        "Position": "Professor, IISER Tirupati",
        "Category": "Guest Faculty",
        "Degree": "Ph.D - IISc Bangalore, India",
        "AreasofInterest": "Physical Chemistry, Electrochemistry, Nanostructured Materials, Energy Storage",
        "Email": "vijay@iisertirupati.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof. Vijayamohanan K Pillai.jpg"
    },
    {
        "Name": "Prof. K. Vidyasagar",
        "NameLink": "http://chem.iitm.ac.in/faculty/mangalasunderkrishnan/",
        "Position": "Professor, IIT Madras",
        "Category": "Guest Faculty ",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Solid State Chemistry",
        "Email": "kvsagar@iitm.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof. K. Vidyasagar.jpg"
    }

]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="CHEMISTRY" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">

                            <div className="section-Position center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                               
                                <h3>CHEMISTRY</h3>
                            </div>
                        </div>
                    </div>
                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={2} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{HD.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Adchemistry-departmentjunct Faculty--------------------------------------------------- */}
                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Adjunct Faculty</h3>
                                {AdjunctFaculty.map((AdjunctFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={AdjunctFaculty.NameLink}>
                                                        <img src={AdjunctFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={AdjunctFaculty.NameLink}>{AdjunctFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{AdjunctFaculty.Position}</p>
                                                    <p className="text-dark">{AdjunctFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {AdjunctFaculty.AreasofInterest}</p>

                                                    {(AdjunctFaculty.Phone !== undefined && AdjunctFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{AdjunctFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {AdjunctFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/*--------------------------- Guest Faculty */}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to="#">
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}



export default Main